<template>
  <module-block
    class="home-hero"
    block="transparent"
  >
    <div class="home-hero__inner group group--first group--last">
      <div class="home-hero__content">
        <h1 class="home-hero__heading h1 mt0 fw-semibold" v-html="hero.heading"/>
        <p
          v-for="(copy, index) in hero.content"
          :key="index"
          class="home-hero__copy p"
          v-html="copy"
        />
      </div>
      <div class="home-hero__image tac">
        <img class="mw-100" :src="hero.image" alt="">
      </div>
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';
import ModuleForm from 'modules/Form';

// Export
export default {
  name: `home-hero`,

  // Components
  components: {
    ModuleBlock,
    ModuleForm,
  },

  // Data
  data () {
    return {
      hero: {
        heading: `Let the work speak for itself`,
        image: require(`images/info/icon-tooth-magnifying.svg`),
        content: [
          `You spent years perfecting your trade and attend CE courses annually, all with a \
          focus on delivering quality dental care. However, patient reviews focus on wait times, \
          office décor, friendliness and cost. While these things matter to patients, what about \
          the work itself? Dentists need a way to demonstrate quality and let the work speak for itself.`,
          `<b>Build your business on quality</b>`,
          `With VeriTooth you can demonstrate quality dentistry to new and existing patients.`,
        ],
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// Hero.vue?a645acdc